import { render } from "./payment-header.vue?vue&type=template&id=f80e146a&scoped=true"
import script from "./payment-header.vue?vue&type=script&lang=js"
export * from "./payment-header.vue?vue&type=script&lang=js"

import "./payment-header.vue?vue&type=style&index=0&id=f80e146a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80e146a"]])

export default __exports__